import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_QUERY = gql`
  query locationTypesAndLocationTypeCategories {
    locationTypesAndLocationTypeCategories {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
`

export default LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_QUERY
